import { render, staticRenderFns } from "./UiInput.vue?vue&type=template&id=57d8fd3c&lang=pug&"
import script from "./UiInput.vue?vue&type=script&lang=ts&"
export * from "./UiInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports